import { render, staticRenderFns } from "./BaseCotentArea.vue?vue&type=template&id=2f2a8780&scoped=true"
import script from "./BaseCotentArea.vue?vue&type=script&lang=js"
export * from "./BaseCotentArea.vue?vue&type=script&lang=js"
import style0 from "./BaseCotentArea.vue?vue&type=style&index=0&id=2f2a8780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a8780",
  null
  
)

export default component.exports